import { Container, Menu, Icon, Button, Dropdown, Dimmer, Loader } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import './style.less'
import { background } from '../../assets'
import { useStore } from '../../stores/useStoreProfile'
import { useEffect } from 'react'
import rest from '../../rest'
import { useState } from 'react'
import { UserType } from '../../pages/auth/store'

type Props = {
  children: any,
}

const restApi = process.env.REACT_APP_REST_API

const HomePage = ({ children }: Props) => {
  const { store, loading, api, modoApresentacao } = useStore()
  const [user, setUser] = useState<UserType>()

  const style = {
    backgroundImage: `url(${background})`,
    backgroundSize: 'cover'
  }

  useEffect(() => {
    rest(`user/?username=${localStorage.getItem('username')}`).then(
      ({ results }) => { setUser(results[0]) }
    )
  }, [])

  return <Container fluid className='home-page' style={style}>
    <Dimmer active={loading} page>
      <Loader size='massive' />
    </Dimmer>
    {!modoApresentacao
      ? <Menu stackable>
        <Menu.Item>
          <Link to='/'>
            <Icon name='home' />
          </Link>
        </Menu.Item>
        <Menu.Item
          icon='tv'
          nameid='apresentacao-on'
          name='Modo Apresentação'
          onClick={() => api.setModoApresentacao(true)}
        />
        {user?.is_staff &&
        <Menu.Item>
          <Link to='/admin/'>
            Admin
          </Link>
        </Menu.Item>
        }
        <Menu.Menu position='right'>
          <Menu.Item>
            <a href={`${restApi}/static/manual/Manual-Prioritarios.pdf`} target="_blank">
              <Icon name='book' />
              Manual de uso
            </a>
          </Menu.Item>
          <Dropdown item text={store.username}>
            <Dropdown.Menu>
              <Dropdown.Item
                icon='sign out' text='Sair'
                onClick={() => api.setToken('')}
              />
            </Dropdown.Menu>
          </Dropdown>
        </Menu.Menu>
      </Menu>
      : <Button
        basic
        icon='tv'
        nameid='apresentacao-off'
        title='Sair do modo apresentação'
        onClick={() => api.setModoApresentacao(false)}
      />
    }
    <Container fluid>
      {!loading ? children : null}
    </Container>
  </Container>
}

export default HomePage
